import Services from "../../../../../server/com/silkplm/rpc/plm/services/_RpcIndex.js";

import AttributesInCategory from "../../../../../server/com/silkplm/rpc/plm/AttributesInCategory.js";
import DataImport from "../../../../../server/com/silkplm/rpc/plm/DataImport.js";
import EANGenerator from "../../../../../server/com/silkplm/rpc/plm/EANGenerator.js";
import HintConfiguration from "../../../../../server/com/silkplm/rpc/plm/HintConfiguration.js";
import WclTemplates from "../../../../../server/com/silkplm/rpc/plm/WclTemplates.js";

class Plm{
    constructor() {
            /** @type {Services} */
            this.services = new Services();

            /** @type {module:src/server/com/silkplm/rpc/plm/AttributesInCategory.AttributesInCategory} */
            this.AttributesInCategory = new AttributesInCategory();
            /** @type {module:src/server/com/silkplm/rpc/plm/DataImport.DataImport} */
            this.DataImport = new DataImport();
            /** @type {module:src/server/com/silkplm/rpc/plm/EANGenerator.EANGenerator} */
            this.EANGenerator = new EANGenerator();
            /** @type {module:src/server/com/silkplm/rpc/plm/HintConfiguration.HintConfiguration} */
            this.HintConfiguration = new HintConfiguration();
            /** @type {module:src/server/com/silkplm/rpc/plm/WclTemplates.WclTemplates} */
            this.WclTemplates = new WclTemplates();
    }
}

export default Plm;

